export default __webpack_public_path__ + "static/media/19.eb5b6f5f.png";